"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESportIconColorView = exports.EColor = void 0;
// TODO: Move all colors strings to enum
var EColor;
(function (EColor) {
    EColor["EMPTY"] = "none";
})(EColor || (exports.EColor = EColor = {}));
var ESportIconColorView;
(function (ESportIconColorView) {
    ESportIconColorView["BLACK"] = "black";
    ESportIconColorView["BLACK_2"] = "black2";
    ESportIconColorView["BLUE_1"] = "blue1";
    ESportIconColorView["BLUE_2"] = "blue2";
    ESportIconColorView["BLUE_3"] = "lightBlue";
    ESportIconColorView["BLUE_4"] = "blue4";
    ESportIconColorView["BLUE_5"] = "blue5";
    ESportIconColorView["BROWN"] = "brown";
    ESportIconColorView["BROWN_1"] = "brown1";
    ESportIconColorView["GRAY"] = "gray";
    ESportIconColorView["GRAY_1"] = "gray_1";
    ESportIconColorView["GREEN"] = "green";
    ESportIconColorView["GREEN_1"] = "green1";
    ESportIconColorView["GREEN_2"] = "green2";
    ESportIconColorView["GREEN_3"] = "green3";
    ESportIconColorView["GREEN_4"] = "green4";
    ESportIconColorView["ORANGE"] = "orange";
    ESportIconColorView["ORANGE_1"] = "orange1";
    ESportIconColorView["PURPLE"] = "purple";
    ESportIconColorView["PURPLE_1"] = "purple1";
    ESportIconColorView["PURPLE_2"] = "purple2";
    ESportIconColorView["RED"] = "red";
    ESportIconColorView["RED_1"] = "red1";
    ESportIconColorView["RED_2"] = "red2";
    ESportIconColorView["RED_3"] = "red3";
    ESportIconColorView["YELLOW"] = "yellow";
    ESportIconColorView["YELLOW_1"] = "yellow1";
    ESportIconColorView["YELLOW_2"] = "yellow2";
    ESportIconColorView["YELLOW_3"] = "yellow3";
    ESportIconColorView["YELLOW_4"] = "yellow4";
    ESportIconColorView["NONE"] = "none";
})(ESportIconColorView || (exports.ESportIconColorView = ESportIconColorView = {}));
//# sourceMappingURL=SportColors.types.js.map